module.exports = __webpack_public_path__ + "img/success-payment.833ea15c.png";